import React from 'react';

import { Section, Grid } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import { loadApplications } from 'scenes/Influencers/Briefs/sources/fields';

import { NAME, APPLICATION, BRIEF_URL, DESCRIPTION } from './constants';
import { BriefFormValidationSchema } from './schemas';
import { validateUri } from './validation';

const BriefForm = withForm({
  validationSchema: BriefFormValidationSchema,
  enableReinitialize: true,
})(
  ({
    children,
    title,
    subTitle,
    loading,
    onClose,
    onExited,
    open,
    entityId,
  }) => {
    return (
      <SidePageV2
        onClose={onClose}
        onExited={onExited}
        open={open}
        loading={loading}
        size={'lg'}
      >
        <SidePageV2.Title
          title={title}
          subTitle={subTitle}
          entityId={entityId}
        />
        <SidePageV2.NewBody>
          <Section>
            <Grid container spacing={3}>
              <Grid item xs={7}>
                <FormField.TextField
                  label={'Name'}
                  required={true}
                  padding={0}
                  name={NAME}
                  helper={'Should be unique per application'}
                />
              </Grid>
              <Grid item xs={5}>
                <FormField.Select
                  label={'Application'}
                  padding={0}
                  required={true}
                  name={APPLICATION}
                  source={loadApplications}
                  lazy={true}
                />
              </Grid>
              <Grid item xs={12}>
                <FormField.TextField
                  label={'URL'}
                  required={true}
                  padding={0}
                  name={BRIEF_URL}
                  validate={validateUri}
                />
              </Grid>
              <Grid item xs={12}>
                <FormField.TextField
                  multiline={true}
                  minRows={1}
                  label={'Description'}
                  padding={0}
                  name={DESCRIPTION}
                />
              </Grid>
            </Grid>
          </Section>
        </SidePageV2.NewBody>
        <SidePageV2.Actions>
          <SidePageV2.CloseButton />
          <SidePageV2.SubmitButton />
        </SidePageV2.Actions>
        {children}
      </SidePageV2>
    );
  }
);

export default BriefForm;
